<template>
  <b-row>
    <b-col cols="12" class="container min-vh-100">
      <ValidationObserver ref="form">
        <b-row>
          <b-card class="w-100 h-100">
            <b-col cols="12" md="12" class="mt-3 mb-1">
              <ValidationProvider
                rules="required"
                name="ชื่อกลุ่มสิทธิ์"
                v-slot="{ errors }"
              >
                <b-form-group label="ชื่อกลุ่มสิทธิ์" label-for="roleName">
                  <b-form-input
                    id="roleName"
                    v-model="role.roleName"
                    placeholder="กรุณากรอก ชื่อกลุ่มสิทธิ์"
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-col>

            <b-col cols="12"></b-col>

            <b-col cols="12" md="6" class="mb-5">
              <b-form-group label="สถานะการใชข้งาน">
                <b-form-radio-group
                  id="isActive"
                  v-model="role.isActive"
                  :options="activeOptions"
                  name="radio-is-active"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" class="d-flex justify-content-between">
              <b-button variant="secondary" @click="onCancelBtnClicked">
                ยกเลิก
              </b-button>
              <b-button variant="primary" @click="onSubmitBtnClicked">
                บันทึกข้อมูล
              </b-button>
            </b-col>
          </b-card>
        </b-row>
      </ValidationObserver>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormRadioGroup,
} from "bootstrap-vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import * as roleStore from "@/store/api/role/index.js";
import * as userData from "@/auth/localStorageUtils.js";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      role: {
        isActive: true,
      },
      activeOptions: [
        { text: "ใช้งาน", value: true },
        { text: "ไม่ใช้งาน", value: false },
      ],
    };
  },
  created() {
    const _this = this;
    if (this.$route.query.id == null) {
    } else {
      const id = this.$route.query.id;
      this.getRoleById(id);
    }
    
  },
  methods: {
    getRoleById(id) {
      const _this = this;

      roleStore
        .getById(id)
        .then((response) => {
          _this.role = response.data.data;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onSubmitBtnClicked() {
      const _this = this;

      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        
        this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          _this.role.updateBy = userData.userId();

          roleStore
            .updateItem(_this.role)
            .then((response) => {
              if (response.data.success === true) {
                _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });

                window.open(
                  _this.$router.resolve({
                    name: "role",
                  }).href,
                  "_self"
                );
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
      })

      
    },
    onCancelBtnClicked() {
      window.open(this.$router.resolve({ name: "role" }).href, "_self");
    },
  },
};
</script>

<style lang="scss"></style>
